import React from 'react';
import PropTypes from 'prop-types';

import { uiConfigTable } from './conf';

// Components
import Table from '../../../../../../../../../../../components/Table';
import { Spinner } from '../../../../../../../../../../../components/Spinner';
import { ConstraintTypeModal } from '../ConstraintTypeModal';

// Context
import { CriteriaStoreContext } from '../../../../../../../../../state/criteria/context';

// Hooks
import { useGetCodeSystems } from '../../../../../../../../../../../common/hooks/useGetCodeSystems';

// Utils
import { translateUIConfigForTable } from '../../../../../../../../../../../common/utility';

export const CodeSystemTableModal = (props) => {
    const { sessionToken } = React.useContext(CriteriaStoreContext);
    const { data, isLoading } = useGetCodeSystems({ sessionToken });
    const { columns, initialState } = translateUIConfigForTable(uiConfigTable);

    return (
        <ConstraintTypeModal header={'Code Systems'} id={'constraint-type-code-systems-modal'} {...props}>
            {!isLoading ? (
                <Table
                    withHeader={true}
                    columns={columns}
                    data={data}
                    withActions={false}
                    rowClickAction={(rowData) => props?.onSelect?.(rowData)}
                    id={'code-systems-manager'}
                    label={'Code Systems'}
                    showControlDeck={true}
                    paginated={true}
                    loading={isLoading}
                    initialState={initialState}
                />
            ) : (
                <Spinner size={'2.3rem'} color={'#7f7f7f'} style={{ margin: '0 auto' }} />
            )}
        </ConstraintTypeModal>
    );
};

CodeSystemTableModal.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onSelect: PropTypes.func
};

export default CodeSystemTableModal;
